<template>
  <div class="w100 banner" :style="{ 'background-image': `url(${baseUrl}images/hcxy-banner.png)` }" @click="bannerClick" id="banner">
    <div class="w120 mc flex-box banner-main">
      <div class="flex-1" style="padding-top: 100px;">
        <div class="w100">
          <p style="color: #4d4d4d;">
            <!--<span class="font-32">要办事上一网通办平台</span>-->
            <span class="font-32">要办事上网上办事大厅</span>
            <span class="ml20 font-20">高效 便捷 省时</span>
          </p>
          <div class="w90 flex-box banner-search">
            <div class="flex-1">
              <el-input
                class="w100 banner-inp"
                prefix-icon="el-icon-search"
                placeholder="请输入您要办理的业务"
                clearable
                v-model="search"
                @focus="onFocus"
                @input="onInput"
                @keyup.enter.native="onSearch"
              ></el-input>
            </div>
            <div class="banner-search-btn" @click="onSearch">搜索</div>

            <div class="search-content" v-if="historyShow" v-loading="searchLoading">
              <p class="search-title">历史搜索</p>
              <div class="search-item" v-for="(item, index) in searchHistory" :key="index" @click="historyClick(item)">{{item}}</div>
            </div>

            <div class="search-content" v-if="searchContentShow" v-loading="searchLoading">
              <div class="search-item" v-for="(item, index) in searchContent" :key="index" @click="goServer(item,1)">{{item.serveName}}</div>
              <div style="width: 100%;line-height:50px; text-align:center; color: #999" v-if="searchContent.length===0">没有数据</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 flex-box al-c">
        <div class="flex-1"></div>
        <div class="pt20 pb20 pl20 pr20 banner-hot-box" v-loading="hotServerLoading">
          <p class="font-20" style="color: #bb282e;">热门服务</p>
          <div class="w100 mt20 pb10 flex-box" style="color: #666666;">
            <div class="flex-1 pl10 pr10">
              <template v-for="(item, index) in hostServer">
                <p class="mt10 mb10 pl20 ellipsis font-16 cu-p banner-serve-item" :key="item.serveId" v-if="index<3" @click="goServer(item,1)">
                  {{item.serveName.length > 10 ? item.serveName.substring(0,10) + '...' : item.serveName}}
                </p>
              </template>
              <p class="mt10 mb10 pl20 ellipsis font-16 cu-p banner-serve-item" v-if="hostServer.length==0">暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <IframeView ref="IframeView"></IframeView>
    <queryTypeModal
            :data="dataModal"
            @close="onDialogClose"/>
  </div>
</template>

<script>
import {getServePage} from '@/api/managementCenter/serveManage'
import {stuAndteachStastic} from '@/api/home/home'
import queryTypeModal from "@/components/common/queryTypeModal.vue";
import IframeView from "@/components/public/IframeView.vue";
import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
export default {
  name: "Banner",
  components: {queryTypeModal, IframeView},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      search: "",
      searchHistory: [],
      searchContent: [],
      historyShow: false,
      searchContentShow: false,
      searchLoading: false,
      hotServerLoading: false,
        dataModal:{
            show: false,
            data:{},
        },
        middlePage:"",
        hostServer: [],
    };
  },
  computed: {},
  created() {
    this.getSearchHistory();
    this.getStuAndteachStastic();
  },
  mounted() {
    if (
      window.sessionStorage.getItem("setConfig") &&
      JSON.parse(window.sessionStorage.getItem("setConfig")).middlePage
    ) {
      this.middlePage = JSON.parse(
        window.sessionStorage.getItem("setConfig")
      ).middlePage;
    }
  },
  destroyed() {},
  methods: {
    historyClick(item){
        this.search = item;
      this.onSearch()
    },
    onSearch(){
      if(!this.search){
        return
      }
      this.searchContentShow = true;
      this.historyShow = false;
      this.searchLoading = true;
      getServePage({current: 1, size: 50, serveName: this.search})
      .then(({data}) => {
        if(data.code == 0){
          this.searchContent = data.data.records || []
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.searchLoading = false;
      })
      // 存储搜索记录
      this.searchHistory.unshift(this.search)
      this.searchHistory = [...new Set(this.searchHistory)];
      if(this.searchHistory.length>10){
        this.searchHistory.pop()
      }
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory))
    },
    getSearchHistory(){
      this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || []
    },
    onFocus(){
      if(!this.search && this.searchHistory.length){
        this.historyShow = true;
      }
    },
    onInput(){
      this.searchContentShow = false;
      if(!this.search && this.searchHistory.length){
        this.historyShow = true;
      }
      if(this.search){
        this.historyShow = false;
      }
    },
    bannerClick(e){
      if(e.target.getAttribute('class')){
        if(
          !e.target.getAttribute('class').includes('el-input__inner') 
          && !e.target.getAttribute('class').includes('el-input__icon') 
          && !e.target.getAttribute('class').includes('banner-search-btn') 
          && !e.target.getAttribute('class').includes('search-item') 
          && !e.target.getAttribute('class').includes('search-content') 
          && !e.target.getAttribute('class').includes('search-title') 
        ){
          this.searchContentShow = false;
          this.historyShow = false;
        }
      }else {
        this.searchContentShow = false;
        this.historyShow = false;
      }
    },
    goServer(row,val){
      console.log(row,val)
        if(row.serveType == '0' && row.queryType == '2'){
            this.dataModal.show = true
            this.dataModal.data = row
        }if(row.serveType == '0' && row.queryType == '1'){
            this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId,row.serveName);
        }
        if(val == '1'){
            if(!this.middlePage){
                this.HandleApply(row)
            }else {
                let routeData = this.$router.resolve({
                    path: `/ServeCenterDetail`,
                    query:{id:row.serveId?row.serveId:row.id}
                });
                window.open(routeData.href);
            }
        }
    },
      onDialogClose() {
          this.dataModal.show = false
      },
    HandleApply(item){
        let processDefId=item.processDefId;
        bpmnStartProcess({processDefId}).then(({data})=>{
            if(data.code==0){
                window.sessionStorage.setItem("processInstId", data.data.processInstId);
                this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
                // window.open(data.data.url);
            }else{
                this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
            }

        }).catch(err=>{
            this.$message.error("服务异常" );
        })
    },
    getStuAndteachStastic(){
      this.hotServerLoading = true;
      stuAndteachStastic()
      .then(({data}) => {
        if(data.code == 0){
          this.hotServerLoading = false
          this.hostServer = data.data;
        }
      }).finally(() => {
        // this.hotServerLoading = false;
      })
    }
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
.banner {
  margin-top: -70px;
  padding-top: 70px;
  height: 415px;
  // background: no-repeat center center;
  // background-size: 100% 100%;
}

.banner-main {
  height: 410px;
}

.banner-search {
  margin-top: 18px;
  height: 60px;
  position: relative;
}

.banner-search >div:first-of-type {
  overflow: hidden;
}

.banner-inp {
  height: 60px;
  border: none;
  line-height: 60px;
  /* padding: 0 10px 0 48px; */
  /* text-indent: 48px; */
  font-size: 16px;
  background: #ffffff no-repeat 18px center;
  background-size: 20px auto;
  box-sizing: border-box;
  /deep/ .el-input__inner {
    height: 60px;
    line-height: 60px;
    border: none;
    padding-left: 40px;
    text-indent: 10px;
  }
  /deep/ .el-input__prefix {
    font-size: 20px;
    .el-input__icon {
      width: 40px;
    }
  }
}

.banner-inp::placeholder {
  color: #cccccc;
}

.banner-inp:focus {
  outline:none;
}

.banner-hot-box {
  width: 520px;
  background: rgba(255, 255, 255, 0.8);
}

.banner-serve-item {
  position: relative;
}

.banner-serve-item::before {
  display: block;
  position: absolute;
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #333333;
  left: 4px;
  top: calc(50% - 2px);
}
.search-content {
  position: absolute;
  width: 484px;
  min-height: 60px;
  max-height: 180px;
  background-color: #fff;
  top: 62px;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.search-title {
  width: 100%;
  padding-left: 8px;
  margin: 5px 0;
}
.search-item {
  margin: 5px 8px;
  color: #999;
  cursor: pointer;
}
</style>
